/** Shared status / panel / chip classes aligned to the HRZyra sidebar teal brand. */

export const brandPanelGradient =
  "bg-gradient-to-r from-sidebar/10 to-sidebar/5 dark:from-sidebar/20 dark:to-sidebar/10";

export const brandPanelBorder =
  "border-sidebar-primary/25 dark:border-sidebar-primary/30";

export const brandCardGradient =
  "bg-gradient-to-br from-sidebar/10 to-sidebar/5 dark:from-sidebar/15 dark:to-sidebar/10";

export const brandChip =
  "bg-sidebar/10 text-sidebar-primary border border-sidebar-primary/30 dark:bg-sidebar/20 dark:border-sidebar-primary/40";

export const brandChipSm =
  "bg-sidebar/10 text-sidebar-primary border-sidebar-primary/30 dark:bg-sidebar/20 dark:text-sidebar-primary dark:border-sidebar-primary/40";

export const brandActionChip =
  "bg-sidebar/5 text-sidebar-primary border border-sidebar-primary/25 hover:bg-sidebar/15 hover:text-sidebar-primary dark:bg-sidebar/10 dark:border-sidebar-primary/30";

export const brandDot = "bg-sidebar-primary";

export const brandHeadingText = "text-sidebar-primary dark:text-sidebar-primary";

export const brandMutedText = "text-sidebar-primary/90 dark:text-sidebar-primary/80";

export const brandIconWrap = "bg-sidebar/10 text-sidebar-primary";

/** Secondary accent for WFH / alternate request categories (kept distinct from brand teal). */
export const secondaryCardGradient =
  "bg-gradient-to-br from-violet-50 to-violet-100/50 dark:from-violet-900/10 dark:to-violet-900/5";

export const secondaryPanelBorder =
  "border-violet-200 dark:border-violet-700/60";

export const secondaryChip =
  "bg-violet-100 text-violet-800 border-violet-300 dark:bg-violet-900/30 dark:text-violet-300 dark:border-violet-700";

export const secondaryDot = "bg-violet-500";
